
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQSection from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';
function Forceurbaniaonrentinpune() {



    const cardData =
    {
        keyword: '  Force Urbania on Rent in Pune',
        heading: 'Samarth Travels: Force Urbania on Rent in Pune',
        headingDescription: 'Samarth Travels offers Force Urbania on rent in Pune, perfect for family outings, corporate travel, outstation tours, and city sightseeing. Our top-class Force Urbania vehicles come equipped with air-conditioning, push-back seats, and roomy interiors to provide superior comfort throughout your journey. With trained drivers, clear pricing, and a customer-first approach, Samarth Travels delivers a safe, smooth, and unforgettable travel experience.',

        top: 'Top Places to Visit in Pune with Samarth Travels',

       "topPlaces": [
    {
      "title": "Shaniwar Wada",
      "description": "Shaniwar Wada is a majestic 18th-century fortification located in the heart of Pune. Once the seat of the powerful Peshwas of the Maratha Empire, it is renowned for its historical significance, massive gateways, and intriguing legends, including ghost stories tied to its mysterious past. Despite being partially destroyed by fire, the remaining structures, especially the Delhi Gate and the fort’s expansive garden layout, provide a fascinating glimpse into Maratha architecture and political history."
    },
    {
      "title": "Aga Khan Palace",
      "description": "Built in 1892 by Sultan Aga Khan III, this sprawling palace is an architectural gem and a key monument in India’s freedom struggle. It served as a prison for Mahatma Gandhi, Kasturba Gandhi, and other leaders during the Quit India Movement. The palace features Italian arches, sprawling gardens, and houses a museum that contains personal belongings of Gandhi and historical photographs. It is also the final resting place of Kasturba Gandhi and Mahadev Desai, adding to its solemn importance."
    },
    {
      "title": "Sinhagad Fort",
      "description": "Located about 30 kilometers from Pune, Sinhagad Fort sits atop the Sahyadri mountains and is a favorite trekking destination for locals and tourists alike. With a history dating back over a thousand years, the fort was famously the site of the battle between the Marathas and the Mughals in 1670. Visitors are drawn to its rugged beauty, crumbling fortifications, and sweeping views of the surrounding valleys, especially during monsoons when the hills are lush green and covered in mist."
    },
    {
      "title": "Pataleshwar Cave Temple",
      "description": "This 8th-century rock-cut temple is carved entirely from a single basalt rock and dedicated to Lord Shiva. Nestled quietly amidst urban Pune, Pataleshwar offers a striking contrast to the city’s bustle. It features a circular Nandi Mandapa and intricately carved columns and sanctums. A protected monument under the Archaeological Survey of India, it’s a peaceful retreat and an excellent example of early Indian rock architecture."
    },
    {
      "title": "Dagdusheth Halwai Ganpati Temple",
      "description": "One of the most famous Ganesh temples in India, Dagdusheth Halwai Ganpati Temple attracts millions of devotees every year, especially during Ganesh Chaturthi. The temple’s grand idol of Lord Ganesh is adorned with gold and jewelry, symbolizing prosperity and devotion. Built by a sweetmaker in the 1800s, the temple also engages in numerous social and cultural initiatives, making it both a religious and community hub."
    },
    {
      "title": "Raja Dinkar Kelkar Museum",
      "description": "Founded by Dr. Dinkar Kelkar in memory of his son, this museum is a treasure trove of Indian heritage. It houses over 20,000 artifacts, including musical instruments, ancient utensils, sculptures, paintings, and even quirky items like betel nut crackers and door frames. The collection offers insight into the daily lives and traditions of Indians across centuries, and its carefully curated exhibits make it a cultural landmark in Pune."
    },
    {
      "title": "Parvati Hill and Temple",
      "description": "Parvati Hill is one of Pune’s oldest heritage sites and offers a combination of spiritual serenity and scenic views. Climbing 103 steps leads to a temple complex dedicated to Goddess Parvati and Lord Shiva. The hill also hosts a small museum, Peshwa-era relics, and panoramic views of the cityscape below, making it ideal for morning walks and peaceful contemplation."
    },
    {
      "title": "Osho Ashram",
      "description": "Located in the serene and green Koregaon Park area, the Osho International Meditation Resort is a global center for spiritual seekers. It offers dynamic meditation sessions, wellness therapies, and luxurious facilities in a Zen-like atmosphere. Known for attracting international visitors, the ashram promotes mindfulness, inner peace, and holistic living through Osho’s teachings."
    },
    {
      "title": "Pune Okayama Friendship Garden",
      "description": "Inspired by the 300-year-old Okayama Korakuen Garden in Japan, this beautifully landscaped space—also known as Pu La Deshpande Garden—is perfect for nature lovers and photographers. The garden features flowing streams, lush lawns, bridges, and seasonal flowers, offering a tranquil escape right in the city. It’s ideal for evening walks and peaceful getaways."
    },
    {
      "title": "Katraj Snake Park and Rajiv Gandhi Zoological Park",
      "description": "Spread over 130 acres, this complex features a zoo, snake park, and animal rescue center. The snake park houses over 160 species of snakes, including cobras and pythons, while the zoo includes tigers, leopards, elephants, and more. Educational exhibits make it an informative and fun spot for children and families, combining entertainment with awareness about wildlife conservation."
    }
  ],

"services": [
    {
        "name": "Force Urbania on Rent in Pune",
        "description": "Samarth Travels offers Force Urbania on rent in Pune for a wide range of travel requirements, including events, outstation trips, and city transfers. Our Force Urbania vans are known for their spacious interiors, smooth suspension, and excellent mileage—making them a perfect fit for family, corporate, or group travel. Enjoy a hassle-free rental experience with punctual services and professional drivers."
    },
    {
        "name": "Force Urbania Hire Pune",
        "description": "Looking to hire a reliable and comfortable vehicle for your next trip in Pune? Samarth Travels provides Force Urbania hire services tailored to your needs. Whether it’s a weekend getaway, a business tour, or a social event, our Force Urbania vans come with plush seating, air-conditioning, and ample luggage space to ensure a relaxed and enjoyable journey for everyone on board."
    },
    {
        "name": "Force Urbania 14 Seater Pune",
        "description": "Travel with medium-sized groups with ease using our Force Urbania 14-seater rental in Pune. With generous legroom, reclining seats, and air-conditioned interiors, this vehicle is ideal for family outings, school or college trips, and team excursions. The 14-seater configuration balances comfort with capacity, making it a popular choice for organized travel in and around the city."
    },
    {
        "name": "Force Urbania Rental Price Pune",
        "description": "At Samarth Travels, we offer competitive and transparent pricing for Force Urbania rentals in Pune. Whether you're booking for a few hours, a full day, or a multi-day trip, our rental packages are designed to suit different budgets. Our rates include vehicle maintenance, driver charges, and fuel options, with no hidden costs—ensuring complete peace of mind for our customers."
    },
    {
        "name": "Rent Force Urbania for Family Travel Pune",
        "description": "Make your next family outing convenient and comfortable with our Force Urbania rentals in Pune. Designed for group travel, these vehicles offer air-conditioning, ergonomic seating, and ample boot space. Whether you're heading to a hill station, a pilgrimage, or a day-long picnic, Force Urbania ensures a smooth ride for all age groups. Let your family travel together, safely and comfortably."
    },
    {
        "name": "Force Urbania for Corporate Events Pune",
        "description": "Samarth Travels provides Force Urbania rentals for corporate events in Pune, ideal for transporting employees or VIP guests to meetings, conferences, or off-site locations. The vehicle offers a professional-grade travel experience with clean interiors, punctual pickup and drop, and dedicated driver service. Trust us to manage your event logistics smoothly and efficiently."
    },
    {
        "name": "Rent Force Urbania for Group Trips Pune",
        "description": "Planning a group trip in Pune or beyond? Our Force Urbania vans are built for group travel, offering seating for up to 14 passengers along with comfort, safety, and space. Whether you're traveling for leisure or business, Samarth Travels ensures that your group stays together and travels in style with our high-quality, reliable Urbania fleet."
    },
    {
        "name": "Force Urbania on Rent for Picnics Pune",
        "description": "Heading for a one-day picnic or weekend outing? Rent a Force Urbania in Pune with Samarth Travels and enjoy a relaxed group experience. With music systems, air-conditioned interiors, and sufficient space for bags and equipment, our Urbania vans are perfect for school groups, families, or office teams seeking a joyful escape from the city."
    },
    {
        "name": "Force Urbania 14-Seater Bus Rental Pune",
        "description": "Our Force Urbania 14-seater bus rental service in Pune is ideal for medium group events and trips. From religious tours to sports team transport, the 14-seater Urbania offers the perfect combination of capacity, comfort, and ease of travel. Samarth Travels ensures each trip is safe, timely, and enjoyable with trained drivers and well-maintained vehicles."
    },
    {
        "name": "Force Urbania for Sightseeing Tours in Pune",
        "description": "Discover the best of Pune with Samarth Travels’ Force Urbania sightseeing tour service. Travel comfortably as you explore top attractions like Shaniwar Wada, Aga Khan Palace, and Parvati Hill. Our professional drivers and guided services make your sightseeing more organized, comfortable, and memorable. Ideal for tourists, school trips, or family tours."
    },
    {
        "name": "Force Urbania Rent Pune to Outstation",
        "description": "Planning a trip outside Pune? Book our Force Urbania for outstation travel to nearby destinations like Lonavala, Mahabaleshwar, or Mumbai. These vans are perfect for highway journeys, with efficient mileage and superior ride quality. Whether it's for business or leisure, Samarth Travels ensures a smooth and stress-free experience from pickup to drop."
    },
    {
        "name": "Force Urbania Hire for Wedding Events Pune",
        "description": "Make wedding logistics easier with Samarth Travels’ Force Urbania hire for wedding events in Pune. Use our vans to transport guests comfortably between venues, hotels, and ceremonies. Clean, air-conditioned, and spacious, our Urbania vehicles add convenience and class to your special occasion with professional coordination and timely service."
    },
    {
        "name": "Force Urbania for Local Transfers Pune",
        "description": "Need reliable transportation within Pune? Choose our Force Urbania vehicles for efficient local transfers. Whether it's a hotel-to-office drop, school run, or a client pickup, we provide timely, safe, and courteous service backed by experienced drivers and clean vehicles. Perfect for regular or one-time local travel needs in Pune."
    },
    {
        "name": "Best Force Urbania Rental Services Pune",
        "description": "Samarth Travels is proud to offer some of the best Force Urbania rental services in Pune. Our focus on quality, punctuality, customer service, and fleet maintenance sets us apart. Whether you need transportation for a few hours or an entire trip, we offer unmatched service standards, flexible pricing, and a travel experience you'll want to repeat."
    }
],
"tableData": [
    ["Force Urbania on Rent in Pune", "Force Urbania Hire Pune"],
    ["Force Urbania 14 Seater Pune", "Force Urbania Rental Price Pune"],
    ["Rent Force Urbania for Family Travel Pune", "Force Urbania for Corporate Events Pune"],
    ["Rent Force Urbania for Group Trips Pune", "Force Urbania on Rent for Picnics Pune"],
    ["Force Urbania 14-Seater Bus Rental Pune", "Force Urbania for Sightseeing Tours in Pune"],
    ["Force Urbania Rent Pune to Outstation", "Force Urbania Hire for Wedding Events Pune"],
    ["Force Urbania for Local Transfers Pune", "Best Force Urbania Rental Services Pune"]
],


"whychoose": [
    {
        "WhyChooseheading": "Trusted Force Urbania Rental Service in Pune",
        "WhyChoosedescription": "We offer dependable and professional Force Urbania van rental services in Pune for all types of events and travel needs. Whether it’s for a corporate seminar, family gathering, or group outing, we ensure smooth, punctual, and comfortable transportation."
    },
    {
        "WhyChooseheading": "Comfortable and Spacious Force Urbania Vans for Groups",
        "WhyChoosedescription": "Our fleet includes Force Urbania vans ranging from 9-seater to 17-seater models. These vans are equipped with comfortable, reclining seats, air-conditioning, ample legroom, and charging ports, ensuring a pleasant and relaxed journey for all passengers."
    },
    {
        "WhyChooseheading": "Experienced and Professional Drivers for Your Convenience",
        "WhyChoosedescription": "Our drivers are highly experienced, punctual, and familiar with Pune's roads. They are trained to handle group transportation and are dedicated to ensuring a safe, smooth, and timely journey for your group."
    },
    {
        "WhyChooseheading": "Affordable and Transparent Pricing for Force Urbania Rentals",
        "WhyChoosedescription": "We provide affordable and transparent pricing with no hidden fees. Whether you need the Force Urbania for a few hours or an entire day, we offer flexible rental packages that suit your budget while maintaining high-quality service."
    },
    {
        "WhyChooseheading": "24/7 Availability for Your Event or Travel Schedule",
        "WhyChoosedescription": "We understand that events and travel can happen at any hour. That's why we offer 24/7 availability for renting Force Urbania vans, ensuring you can schedule transportation at your convenience, whether it’s an early morning or late night."
    },
    {
        "WhyChooseheading": "Easy Booking with Real-Time Updates for Smooth Coordination",
        "WhyChoosedescription": "Booking your Force Urbania is simple and hassle-free through our website or customer care. After confirming your booking, you’ll receive real-time tracking updates, driver contact details, and expected bus arrival times, ensuring smooth logistics."
    },
    {
        "WhyChooseheading": "Clean, Sanitized, and Well-Maintained Force Urbania Vans",
        "WhyChoosedescription": "We take cleanliness and safety seriously. Our Force Urbania vans are cleaned and sanitized before every trip, maintaining a hygienic environment. Regular maintenance ensures all vehicles run smoothly and are ready for your group’s comfort."
    },
    {
        "WhyChooseheading": "Multiple Convenient Payment Options",
        "WhyChoosedescription": "We provide multiple payment options for your convenience, including UPI, credit/debit cards, digital wallets, and cash, ensuring a secure and smooth booking experience for individuals, companies, and event planners alike."
    }
]



















    }

const faqData = [
    {
        id: 1,
        question: 'How do I book a Force Urbania on a rent (daily rental) basis in Pune with Samarth Travels?',
        answer: 'Booking a Force Urbania on a daily rental basis is simple. You can contact Samarth Travels via phone or through the website. Just share your travel dates, number of passengers, and trip details. We will schedule the Urbania as per your requirements.',
    },
    {
        id: 2,
        question: 'What is included in the daily rental (tent) for Force Urbania?',
        answer: 'The daily rental includes the vehicle, driver, and fuel for a fixed kilometer limit (usually 300 km/day). Additional charges apply if you exceed the daily km limit, or incur tolls, parking fees, or inter-state taxes.',
    },
    {
        id: 3,
        question: 'What types of Urbania vans are available for daily rent?',
        answer: 'Samarth Travels offers both 13+1 and 17+1 seater Force Urbania vans for daily rentals. These are ideal for group tours, weddings, airport transfers, or corporate usage and come equipped with luxury amenities.',
    },
    {
        id: 4,
        question: 'What are the rent (per day) charges for Force Urbania in Pune?',
        answer: 'Tent charges start from ₹10,000 per day for a 13-seater and ₹10,799 per day for a 17-seater Urbania, with an included 300 km limit. The pricing is competitive and offers excellent value for premium travel.',
    },
    {
        id: 5,
        question: 'Is the Force Urbania suitable for outstation and multi-day tours?',
        answer: 'Yes, Force Urbania vans are perfectly suited for long-distance and multi-day travel. With pushback seats, air conditioning, USB charging, and large luggage space, they offer high comfort for extended journeys.',
    },
    {
        id: 6,
        question: 'Can I book Urbania for multiple days on a rent basis?',
        answer: 'Yes, you can book Urbania vans for multiple days. Just let us know your travel itinerary in advance, and we’ll make the necessary arrangements including driver accommodation and vehicle permits if required.',
    },
    {
        id: 7,
        question: 'Is customer support available during multi-day or rent-based rentals?',
        answer: 'Absolutely! Samarth Travels provides 24/7 support during all rental periods, including rent-based rentals. You can reach our helpline at any time for assistance during your journey.',
    },
];

const testimonials = [
    {
        name: 'Mr. Sandeep Naik',
        role: 'Tour Organizer',
        text: 'We booked a 17-seater Urbania on a rent basis from Samarth Travels for a 3-day tour around Pune and Nashik. The van was very comfortable, the driver was friendly and professional, and the entire trip went smoothly. Great value for money!',
        image: '/img/testimonial/testi_urbania_sandeep.jpg',
    },
    {
        name: 'Ms. Aarti Deshmukh',
        role: 'Destination Wedding Planner',
        text: 'I hired a 13-seater Urbania on a day-rental basis for shuttling guests during a wedding event. The van was premium and very clean, and the team at Samarth Travels ensured everything went on time. I will definitely recommend them to others.',
        image: '/img/testimonial/testi_urbania_aarti.jpg',
    },
];



























    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 9860256019",
            "+91 9527500025",

        ],
        email: "samarthtravels9119@gmail.com"
    };


   const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: " Tempo Traveller Pune",
        },
        {
            place: "/images/keyword/2.jpg",
            text: " Tempo Traveller on Rent Pune",
        },
        {
            place: "/images/keyword/3.jpg",
            text: " Bus on Rent in Pune",
        },
        {
            place: "/images/keyword/4.jpg",
            text: " Tempo Traveller on Rent",
        },
        {
            place: "/images/keyword/5.jpg",
            text: " Tempo Traveller Rent in Pune",
        },
        {
            place: "/images/keyword/6.jpg",
            text: " Tempo Traveller Hire in Pune",
        },
        {
            place: "/images/keyword/7.jpg",
            text: " Mini Bus for Rent",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Bus on Rent Hire",
        },

        {
            place: "/images/keyword/9.jpg",
            text: " Bus on Rent Pune",
        },
        {
            place: "/images/keyword/10.jpg",
            text: " Bus Rental in Pune",
        },

        {
            place: "/images/keyword/11.jpg",
            text: " Hire Tempo Traveller",
        },
        {
            place: "/images/keyword/12.jpg",
            text: " Bus Hire in Pune",
        },
        {
            place: "/images/keyword/13.jpg",
            text: " Ac Tempo Traveller Rent Pune",
        },
        {
            place: "/images/keyword/14.jpg",
            text: " Bus Hire For Outstation",
        },
        {
            place: "/images/keyword/15.jpg",
            text: " Bus on Rent for Local",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Bus Rental For Wedding",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Bus Rent for Marriage",
        },
        {
            place: "/images/keyword/18.jpg",
            text: " Bus Rental For Corporate Events",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "  Bus Rental for Tour",
        },

        {
            place: "/images/keyword/20.jpg",
            text: "Bus Rental For Corporate in Pune",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Tempo Traveller on Rent in Pune",
        },
        {
            place: "/images/keyword/22.jpg",
            text: " AC Bus On Rent",
        },
        {
            place: "/images/keyword/23.jpg",
            text: " Non Ac Bus Rental Service",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Bus on Hire on Pune to Mahabaleshwar Package Tour ",
        },
        {
            place: "/images/keyword/25.jpg",
            text: "Bus Hire for Picnic",
        },
    ];


    const images = [
        { src: "/images/fleets/1.jpg", alt: "Image 1" },
        { src: "/images/fleets/2.jpg", alt: "Image 1" },
        { src: "/images/fleets/3.jpg", alt: "Image 1" },
        { src: "/images/fleets/4.jpg", alt: "Image 1" },
        { src: "/images/fleets/5.jpg", alt: "Image 1" },
        { src: "/images/fleets/6.jpg", alt: "Image 1" },
        { src: "/images/fleets/7.jpg", alt: "Image 1" },
        { src: "/images/fleets/8.jpg", alt: "Image 1" },
        { src: "/images/fleets/9.jpg", alt: "Image 1" },


    ];




const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Force Urbania on Rent in Pune",
  "image": "https://samarthtravels.com/assets/images/force-urbania-on-rent-pune.jpg",
  "description": "Rent a Force Urbania vehicle in Pune for family travel, corporate events, picnics, group trips, sightseeing tours, and more. Affordable rental options available for local transfers, wedding events, outstation trips, and more.",
  "brand": {
    "@type": "Brand",
    "name": "Samarth Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "22000",
    "availability": "https://schema.org/InStock",
    "url": "https://samarthtravels.com/force-urbania-on-rent-pune"
  }
};





    return (
        <div>

<Helmet>
  <title>Force Urbania on Rent in Pune | Affordable & Luxury Bus Hire | Samarth Travels</title>
  <meta 
    name="description" 
    content="Rent a Force Urbania vehicle in Pune for family travel, corporate events, picnics, group trips, sightseeing tours, and more. Affordable rental options available for local transfers, wedding events, outstation trips, and more." 
  />
  <meta 
    name="keywords" 
    content="Force Urbania on rent in Pune, Force Urbania hire Pune, Force Urbania 14 seater Pune, Force Urbania rental price Pune, Rent Force Urbania for family travel Pune, Force Urbania for corporate events Pune, Rent Force Urbania for group trips Pune, Force Urbania on rent for picnics Pune, Force Urbania 14-seater bus rental Pune, Force Urbania for sightseeing tours in Pune, Force Urbania rent Pune to outstation, Force Urbania hire for wedding events Pune, Force Urbania for local transfers Pune, Best Force Urbania rental services Pune" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="breadcumb-wrapper" data-bg-src="/images/breadcumb-bg.jpg">
                <div className="container">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title text-center">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>



            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/42.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2 bg-foootr'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Samarth Travels </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQSection faqs={faqData} accordionId="drivingAccordion" />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword
                                data={testimonials}
                                title="What Our Clients Are Saying"
                                subtitle="Customer Feedback"
                            />


                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #FF8F1F',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#FF8F1F' }}>
                                            <h4 className=" lead fw-semibold whitt textt-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+919860256019" className="d-block  text-white">+91 9860256019</a>
                                                <a href="tel:+919527500025" className="d-block  text-white">+91 9527500025</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Email</h4>
                                                <a href="mailto:samarthtravels9119@gmail.com" className=" text-white d-block">
                                                    samarthtravels9119@gmail.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#FF8F1F' }}>
                                                <h4 className=" fw-semibold lead whitt textt-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Samarth Travels <br />
                                                        Flat no 201, Juhi Building, Suyash Shrushti Society, Tukai darshan Hadapsar, Pune- 411028
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Forceurbaniaonrentinpune;